import Block from './Block'
import HTML from '../html'
import {ultraSelect} from '../html-components'

export default class PropertyInfoTabs extends Block {
    constructor(blockRoot) {
        super(blockRoot)

        this.transitionDuration = 500
        this.blocked = false
        this.initScroll = 0


        this.header = $('#site-header')
        this.nav = this.root.find('.info-tabs__nav')
        this.navWrapper = this.root.find('.info-tabs__nav-wrapper')
        this.sectionSelect = this.root.find('.info-tabs__nav__select')
        this.scrollBase = this.root.find('.info-tabs__scrollbase')
        this.content = this.root.find('.info-tabs__content')
        this.interestForm = this.root.find('.interest-form')

        var sections = Array.prototype.slice.call(this.content.find('section'))
        sections = sections.filter(s => !!s.dataset.sectionName)

        this.navList = HTML('ul').classes('info-tabs__nav__list').render()

        this.sections = sections.map((section, index) => {
            var sect = {
                slug: section.dataset.sectionName,
                sectionNode: section,
                navNode: HTML('li')
                    .classes('info-tab')
                    .append(
                        HTML('a')
                            .classes('info-tab__link')
                            .attr({
                                href: '#',
                                title: section.dataset.sectionName,
                            })
                            .content(section.dataset.sectionName)
                            .on('click', (event, node) => {
                                event.preventDefault()

                                let hheight = $(section).offset().top > window.pageYOffset ? 0 : this.header.outerHeight();
                                $('html, body').animate({
                                    scrollTop: $(section).offset().top - hheight - $(node).outerHeight() - 20,
                                })
                            })
                            .render(),
                    )
                    .render(),
            }
            $(window).on('scroll', event => { // Highlight button of a section that intersects screen middle line
                let screenMiddle = window.pageYOffset + (window.innerHeight / 2)
                if (screenMiddle > $(section).offset().top
                    && screenMiddle < $(section).offset().top + $(section).outerHeight(true)) {
                    this.navList.scrollLeft = sect.navNode.offsetLeft
                    $(sect.navNode).addClass('active').removeClass('inactive')
                } else {
                    $(sect.navNode).removeClass('active').addClass('inactive')
                }
            })
            return sect
        })

        this.initSectionSelect()

        this.navWrapper.append(
            $(this.navList).append(this.sections.map(section => section.navNode)),
        )

        if (this.interestForm.length) {
            this.interestForm.appendTo(this.navWrapper).show()
        }

        if (this.scrollBase.length) {
            this.doOnScroll()
            this.doOnResize()
            // make this sub-menu sticky
            $(window).on('scroll', this.doOnScroll.bind(this))
            $(window).on('resize', this.doOnResize.bind(this))
        }
    }

    doOnResize() {
        this.headerBottomHeight = this.header.find('.site-header__bottom-row').outerHeight(true)
    }

    doOnScroll() {
        let navHeight = this.nav.outerHeight(true)
        let headerHeight = this.header.outerHeight(true)

        let currentScroll = window.pageYOffset

        if (window.pageYOffset >= this.scrollBase.offset().top - this.headerBottomHeight) {
            this.scrollBase.css('height', navHeight + 'px')
            this.nav.addClass('sticky')
            this.nav.css({
                top: 0,
            })

        } else {
            this.scrollBase.css('height', 0)
            this.nav.removeClass('sticky').css('top', 0)
            this.header.removeClass('hidden')
        }


        /* Hide header on scroll */
        if (currentScroll > this.initScroll) {
           this.header.addClass('hidden')
        } else {
            this.header.removeClass('hidden')

            if (this.nav.hasClass('sticky')) {
                this.nav.css({
                    top: headerHeight
                })
            }
        }

        this.initScroll = currentScroll
    }

    initSectionSelect () {
        let select = ultraSelect({
            buttonText: this.sections[0].slug,
            list: this.sections.map(section => {
                return {
                    content: section.slug,
                    events: {
                        event: 'click',
                        callback: (event, element) => {
                            event.preventDefault()
                            $(select).find('.u-select__menu__item__link').removeClass('selected')
                            element.classList.add('selected')
                            $(select).find('.u-select__button__name').html(section.slug)

                            let hheight = $(section.sectionNode).offset().top > window.pageYOffset ? 0 : this.header.outerHeight()
                            $('html, body').animate({
                                scrollTop: $(section.sectionNode).offset().top - hheight - this.nav.outerHeight() - 20,
                            })

                        },
                    },
                }
            }),
        })

        this.sectionSelect.append(select)
    }
}
